import { render, staticRenderFns } from "./AiGeneratorAngularAdapter.vue?vue&type=template&id=380de80a&scoped=true"
import script from "./AiGeneratorAngularAdapter.vue?vue&type=script&lang=js"
export * from "./AiGeneratorAngularAdapter.vue?vue&type=script&lang=js"
import style0 from "./AiGeneratorAngularAdapter.vue?vue&type=style&index=0&id=380de80a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380de80a",
  null
  
)

export default component.exports